module.exports = __webpack_public_path__ + "static/media/checkbox_checked.ef588e0c.svg";